var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88 25.12H37.12C38.7106 25.12 40 23.8306 40 22.24V2.88C40 1.28944 38.7106 0 37.12 0H2.88C1.28944 0 0 1.28944 0 2.88V22.24C0 23.8306 1.28944 25.12 2.88 25.12Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2443 8.56641V16.5378H11.5833L9.59043 9.97313H9.47323V16.5378H7.85547V8.56641H10.5869L12.5094 15.1311H12.6266V8.56641H14.2443Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5963 9.97313V11.837H20.4332V13.2203H17.5963V15.1311H21.1366V16.5378H15.9785V8.56641H21.1366V9.97313H17.5963Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8281 8.56641H23.5279L24.5126 15.1546H24.6884L26.1186 8.56641H27.9942L29.4244 15.1546H29.6002L30.585 8.56641H32.2848L30.7608 16.5378H28.3108L27.0564 10.4772L25.802 16.5378H23.352L21.8281 8.56641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/New.0ee1f676859db5beaafb461afa967c03.svg";
export { ForwardRef as ReactComponent };